'use strict';

export { default } from './dynamicPosView.container';